module.exports = __webpack_public_path__ + "img/graph-bar-fullGrey.1959afc4.svg";